import { ENVIRONMENTS, getEnvFromHostname } from 'pages/utils/getEnvFromHostname';

const envToScriptUrl: Record<ENVIRONMENTS, string> = {
  [ENVIRONMENTS.LOCALHOST]: 'http://localhost:4174/invoicing-pay-balance.es.js',
  [ENVIRONMENTS.DEVELOPMENT]: 'http://localhost:4174/invoicing-pay-balance.es.js',
  [ENVIRONMENTS.STAGING]:
    'https://ls-mfe-assets-cdn.lightspeedstg.app/invoicing/pay-balance/latest.js',
  [ENVIRONMENTS.PRODUCTION]:
    'https://ls-mfe-assets-cdn.lightspeed.app/invoicing/pay-balance/latest.js',
};

export const getPayBalanceScriptUrl = (): string => envToScriptUrl[getEnvFromHostname()];

export const PAY_BALANCE_CUSTOM_ELEMENT = 'invoicing-pay-balance';
